import { render, staticRenderFns } from "./AppSwitcher.vue.js?vue&type=template&id=42eef845!=!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.4.11_@swc+helpers@0.5.17__webpack@5._1c4162b7d48aa5b46a78bee0ed0244ca/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppSwitcher.vue?vue&type=template&id=42eef845"
import script from "./AppSwitcher.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.4.11_@swc+helpers@0.5.17__webpack@5._1c4162b7d48aa5b46a78bee0ed0244ca/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppSwitcher.vue?vue&type=script&lang=js"
export * from "./AppSwitcher.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.4.11_@swc+helpers@0.5.17__webpack@5._1c4162b7d48aa5b46a78bee0ed0244ca/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.4.11_@swc+helpers@0.5.17__webpack@5._1c4162b7d48aa5b46a78bee0ed0244ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42eef845')) {
      api.createRecord('42eef845', component.options)
    } else {
      api.reload('42eef845', component.options)
    }
    module.hot.accept("./AppSwitcher.vue.js?vue&type=template&id=42eef845!=!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.4.11_@swc+helpers@0.5.17__webpack@5._1c4162b7d48aa5b46a78bee0ed0244ca/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppSwitcher.vue?vue&type=template&id=42eef845", function () {
      api.rerender('42eef845', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/components/ui/AppSwitcher.vue"
export default component.exports